import AmenitiesComponent from "../../../../components/partner/Settings/Amenities/amenities";

export default function Amenities() {
  return <AmenitiesComponent />;
}
